// src/components/SidebarPanel.js
import React, { useLayoutEffect, useRef } from "react";


export default function SidebarPanel(props) {
  const {
    menuVisible,

    // ✅ Proje seçimi (dropdown)
    projects,
    selectedProjectId,
    onProjectChange,
    createEmptyProject,
    renameProject,
    deleteProject,

    paftaTab,
    setPaftaTab,
    aktifPaftaSayisi,
    pasifPaftaSayisi,
    searchTerm,
    setSearchTerm,
    selectedTeamId,
    setSelectedTeamId,
    teams,
    paftalar,
    points,
    fillAndDownloadNATTForm,
    openTeamModal,
    paftaGorunurlukDegistir,
    makePaftaPasif,
    makePaftaAktif,
    setSelectedPaftaForTeams,
    deletePafta,
    downloadPafta,
    handleKMZUpload,
    // 🔵 NATT tarih filtresi (başlangıç & bitiş)
    nattFilterStart,
    setNattFilterStart,
    nattFilterEnd,
    setNattFilterEnd,
    canManagePaftaAndTeams,
    user, // ✅ Admin kontrolü için
  } = props;

  const sidebarRootRef = useRef(null);
  const sidebarInstanceIdRef = useRef(
    `geo_sidebar_${Date.now()}_${Math.random().toString(36).slice(2)}`
  );

  useLayoutEffect(() => {
    const el = sidebarRootRef.current;
    if (!el) return;

    // Aynı sayfada yanlışlıkla birden fazla SidebarPanel kalırsa eskilerini temizle
    const all = document.querySelectorAll('[data-geo-sidebar="1"]');
    all.forEach((node) => {
      if (node !== el) node.remove();
    });
  }, []);

  const LEGACY_DEFAULT_PROJECT_ID = "main_project";

  const isDefaultProject = selectedProjectId === LEGACY_DEFAULT_PROJECT_ID;

  // ✅ Yetki Filtreleme: Kullanıcı sadece yetkili olduğu projeleri görmeli (Superadmin hariç)
  const filteredProjects = React.useMemo(() => {
    if (!user) return [];
    if (user.role === "superadmin" || (user.projectRoles && user.projectRoles["ALL"] === "superadmin")) {
      return projects || [];
    }
    if (!user.projectRoles) {
      // Geriye dönük uyumluluk (eski tip kullanıcı girişi)
      return (projects || []).filter(p => String(p.id) === String(user.projectId));
    }
    // Çoklu proje yetkisi
    return (projects || []).filter(p => user.projectRoles[p.id]);
  }, [user, projects]);

  const getProjectRole = React.useCallback(
    (projectId) => {
      if (!user) return null;
      if (user.role === "superadmin" || user.projectRoles?.ALL === "superadmin") {
        return "superadmin";
      }
      if (user.projectRoles?.[projectId]) {
        return user.projectRoles[projectId];
      }
      if (String(user.projectId) === String(projectId)) {
        return user.role || "user";
      }
      return null;
    },
    [user]
  );

  const getRoleLabel = React.useCallback((role) => {
    if (role === "superadmin") return "Süper Admin";
    if (role === "project_admin") return "Proje Yöneticisi";
    if (role === "user") return "Kullanıcı";
    return "";
  }, []);

  const selectedProject =
    (projects || []).find((p) => String(p.id) === String(selectedProjectId)) || null;
  const selectedProjectName = selectedProject?.name || "";
  const selectedProjectRoleLabel = getRoleLabel(getProjectRole(selectedProjectId));

  const palette = {
    panelBgTop: "rgba(248, 250, 252, 0.97)",
    panelBgBottom: "rgba(255, 255, 255, 0.94)",
    textPrimary: "#0f172a",
    textSecondary: "#475569",
    border: "#cbd5e1",
    borderSoft: "#e2e8f0",
    primary: "#2563eb",
    primarySoft: "#dbeafe",
    accent: "#0f766e",
    accentSoft: "#ccfbf1",
    success: "#16a34a",
    danger: "#dc2626",
    dangerSoft: "#fee2e2",
    disabledBg: "#cbd5e1",
    disabledText: "#475569",
  };

  const fieldStyle = {
    width: "100%",
    padding: "6px 8px",
    fontSize: "0.84rem",
    borderRadius: "8px",
    border: `1px solid ${palette.border}`,
    background: "#ffffff",
    color: palette.textPrimary,
  };

  return (
    <div
      ref={sidebarRootRef}
      data-geo-sidebar="1"
      data-geo-sidebar-instance={sidebarInstanceIdRef.current}
      className={`sidebar ${menuVisible ? "visible" : "hidden"}`}
      style={{
        width: "min(420px, calc(100vw - 20px))",
        boxSizing: "border-box",
        maxHeight: "calc(100vh - 84px)",
        overflowY: "auto",
        overflowX: "hidden",
        background: `linear-gradient(180deg, ${palette.panelBgTop} 0%, ${palette.panelBgBottom} 100%)`,
        backdropFilter: "blur(10px)",
        border: `1px solid ${palette.borderSoft}`,
        borderRadius: "30px",
        padding: "10px 12px",
        position: "absolute",
        top: "64px",
        left: "10px",
        zIndex: 1000,
        boxShadow: "0 8px 22px rgba(15,23,42,0.14)",
        fontFamily: "Inter, sans-serif",
        transition: "all 0.3s ease",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
        <h2 style={{ fontSize: "0.9rem", fontWeight: "800", color: palette.textPrimary, margin: 0 }}>
          🌍 Saha Sistem
        </h2>
      </div>

      {/* === ÜST TAB: AKTİF / PASİF === */}
      <div
        style={{
          display: "flex",
          gap: 6,
          marginBottom: 6,
          paddingBottom: 6,
          borderBottom: `1px solid ${palette.border}`,
        }}
      >
        <div
          onClick={() => setPaftaTab("aktif")}
          onMouseOver={(e) =>
            (e.currentTarget.style.background = "#e2e8f0")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.background = "transparent")
          }
          style={{
            flex: 1,
            textAlign: "center",
            padding: "6px 8px",
            cursor: "pointer",
            fontWeight: "700",
            borderBottom:
              paftaTab === "aktif"
                ? `3px solid ${palette.primary}`
                : "3px solid transparent",
            color: paftaTab === "aktif" ? palette.primary : "#64748b",
            fontSize: "0.84rem",
            transition: "0.2s",
            userSelect: "none",
            borderRadius: "6px 6px 0 0",
            background: paftaTab === "aktif" ? palette.primarySoft : "transparent",
          }}
        >
          Aktif Pafta ({aktifPaftaSayisi})
        </div>
        <div
          onClick={() => setPaftaTab("pasif")}
          onMouseOver={(e) =>
            (e.currentTarget.style.background = "#e2e8f0")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.background = "transparent")
          }
          style={{
            flex: 1,
            textAlign: "center",
            padding: "6px 8px",
            cursor: "pointer",
            fontWeight: "700",
            borderBottom:
              paftaTab === "pasif"
                ? `3px solid ${palette.primary}`
                : "3px solid transparent",
            color: paftaTab === "pasif" ? palette.primary : "#64748b",
            fontSize: "0.84rem",
            transition: "0.2s",
            userSelect: "none",
            borderRadius: "6px 6px 0 0",
            background: paftaTab === "pasif" ? palette.primarySoft : "transparent",
          }}
        >
          Pasif Pafta ({pasifPaftaSayisi})
        </div>
      </div>
      {/* === PROJE SEÇİMİ (DROPDOWN) === */}
      <div
        style={{
          display: "flex",
          gap: "8px",
          alignItems: "flex-start",
          marginBottom: "10px",
        }}
      >
        <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
          <select
            value={selectedProjectId || ""}
            onChange={(e) => {
              if (typeof onProjectChange === "function") {
                onProjectChange(e.target.value);
              }
            }}
            style={fieldStyle}
          >
            {filteredProjects.map((p) => {
              return (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              );
            })}
          </select>

          {selectedProjectRoleLabel ? (
            <div
              style={{
                display: "inline-flex",
                width: "fit-content",
                fontSize: "0.72rem",
                fontWeight: 700,
                color: palette.accent,
                background: palette.accentSoft,
                border: "1px solid #99f6e4",
                borderRadius: "999px",
                padding: "3px 8px",
              }}
            >
              Erişim: {selectedProjectRoleLabel}
            </div>
          ) : null}
        </div>

        {/* 🛡️ Sadece Baş Admin Görebilir: Proje Yönetim Butonları */}
        {user?.role === "superadmin" && (
          <>
            <button
              type="button"
              onClick={() => {
                if (typeof createEmptyProject !== "function") return;
                const name = prompt("Yeni proje adı:");
                if (name) createEmptyProject(name);
              }}
              title="Yeni proje oluştur"
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "10px",
                border: "none",
                backgroundColor: "#2563eb",
                color: "#fff",
                cursor: "pointer",
                fontSize: "18px",
                fontWeight: 900,
                lineHeight: 1,
              }}
            >
              +
            </button>

            <button
              type="button"
              onClick={() => {
                if (!selectedProjectId) return;
                if (typeof renameProject !== "function") return;
                const newName = prompt("Yeni proje adı:", selectedProjectName);
                if (newName && newName !== selectedProjectName) {
                  renameProject(selectedProjectId, newName);
                }
              }}
              title="Proje adını değiştir"
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "10px",
                border: "none",
                backgroundColor: "#0f766e",
                color: "#fff",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: 800,
                lineHeight: 1,
              }}
            >
              ✏️
            </button>

            <button
              type="button"
              onClick={() => {
                if (!selectedProjectId) return;
                if (isDefaultProject) return;
                if (typeof deleteProject !== "function") return;
                deleteProject(selectedProjectId);
              }}
              disabled={isDefaultProject || !selectedProjectId}
              title={isDefaultProject ? "Default proje silinemez" : "Projeyi sil"}
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "10px",
                border: "none",
                backgroundColor: isDefaultProject ? "#94a3b8" : "#dc2626",
                color: "#fff",
                cursor: isDefaultProject ? "not-allowed" : "pointer",
                fontSize: "16px",
                fontWeight: 800,
                lineHeight: 1,
              }}
            >
              🗑
            </button>
          </>
        )}
      </div>

      {/* Üst bilgi */}
      <h2
        style={{
          fontSize: "0.8rem",
          fontWeight: "800",
          color: palette.textPrimary,
          marginBottom: "8px",
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        📂
        <div>
          Pafta Yönetim Sistemi
        </div>
      </h2>

      {/* 🔵 SADECE AKTİF SEKMEDE GÖRÜNECEK BLOK */}
      {paftaTab === "aktif" && (
        <>
          {/* Personel / Ekip Alanı */}
          <div
            style={{
              marginBottom: "8px",
              padding: "8px",
              border: `1px solid ${palette.borderSoft}`,
              borderRadius: "10px",
              background: "#ffffff",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "8px",
                marginBottom: "8px",
                alignItems: "center",
                flexWrap: "wrap", // sidebar taşmasın
              }}
            >
              <select
                value={selectedTeamId || "null"}
                onChange={(e) =>
                  setSelectedTeamId(
                    e.target.value === "null" ? null : e.target.value
                  )
                }
                style={fieldStyle}
              >
                <option value="null">Ekip Seçilmedi</option>
                {teams
                  .filter((t) => {
                    const visiblePaftas = paftalar.filter(
                      (p) => p.gorunur
                    );
                    if (visiblePaftas.length !== 1) return false;
                    return t.paftaId === visiblePaftas[0].id;
                  })
                  .map((t) => (
                    <option key={t.id} value={t.id}>
                      {t.name}
                    </option>
                  ))}
              </select>

              <button
                onClick={fillAndDownloadNATTForm}
                style={{
                  padding: "6px 10px",
                  fontSize: "0.8rem",
                  borderRadius: "8px",
                  backgroundColor: palette.accent,
                  color: "#fff",
                  border: "none",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  fontWeight: 700,
                }}
              >
                NATT
              </button>

              {/* 🔵 NATT için tarih aralığı: Başlangıç - Bitiş */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  flexShrink: 0,
                }}
              >
                <span
                  style={{
                    fontSize: "0.7rem",
                    color: palette.textSecondary,
                    fontWeight: 600,
                  }}
                >
                  Tarih:
                </span>

                {/* Başlangıç tarihi ikonu */}
                <label
                  title="Başlangıç tarihi (dahil)"
                  style={{
                    position: "relative",
                    width: 28,
                    height: 28,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "6px",
                    border: nattFilterStart
                      ? `2px solid ${palette.accent}`
                      : `1px solid ${palette.border}`,
                    backgroundColor: nattFilterStart ? "#ecfdf5" : "#ffffff",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="date"
                    value={nattFilterStart || ""}
                    onChange={(e) => setNattFilterStart(e.target.value)}
                    style={{
                      position: "absolute",
                      inset: 0,
                      opacity: 0,
                      cursor: "pointer",
                    }}
                  />
                  <span
                    aria-hidden="true"
                    style={{
                      fontSize: "16px",
                      lineHeight: 1,
                    }}
                  >
                    📅
                  </span>
                </label>

                <span
                  style={{
                    fontSize: "0.75rem",
                    color: "#64748b",
                  }}
                >
                  -
                </span>

                {/* Bitiş tarihi ikonu */}
                <label
                  title="Bitiş tarihi (dahil)"
                  style={{
                    position: "relative",
                    width: 28,
                    height: 28,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "6px",
                    border: nattFilterEnd
                      ? `2px solid ${palette.accent}`
                      : `1px solid ${palette.border}`,
                    backgroundColor: nattFilterEnd ? "#ecfdf5" : "#ffffff",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="date"
                    value={nattFilterEnd || ""}
                    onChange={(e) => setNattFilterEnd(e.target.value)}
                    style={{
                      position: "absolute",
                      inset: 0,
                      opacity: 0,
                      cursor: "pointer",
                    }}
                  />
                  <span
                    aria-hidden="true"
                    style={{
                      fontSize: "16px",
                      lineHeight: 1,
                    }}
                  >
                    📅
                  </span>
                </label>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: "6px",
                alignItems: "center",
                flexWrap: "wrap",
                marginBottom: "8px",
              }}
            >
              <button
                onClick={openTeamModal}
                disabled={!canManagePaftaAndTeams}
                title={
                  canManagePaftaAndTeams
                    ? "Paftaya Ekip Ata (Seçili paftada çalışacak kişileri takıma ekleyin)"
                    : "Bu işlem için proje yöneticisi yetkisi gerekir."
                }
                style={{
                  width: "100%",
                  padding: "6px 8px",
                  backgroundColor: canManagePaftaAndTeams ? palette.primary : palette.disabledBg,
                  color: canManagePaftaAndTeams ? "#fff" : palette.disabledText,
                  border: `1px solid ${canManagePaftaAndTeams ? "#1d4ed8" : palette.border}`,
                  borderRadius: "7px",
                  fontSize: "0.8rem",
                  fontWeight: "700",
                  cursor: canManagePaftaAndTeams ? "pointer" : "not-allowed",
                  lineHeight: 1.15,
                }}
              >
                {canManagePaftaAndTeams ? "👥 Paftaya Ekip Ata" : "🔒 Paftaya Ekip Ata"}
              </button>
            </div>
          </div>

          {/* Pafta Yükleme */}
          <label style={{ display: "block", marginBottom: 8 }}>
            <div
              style={{
                fontSize: "0.85rem",
                marginBottom: 3,
                color: palette.textSecondary,
                fontWeight: "700",
              }}
            >
              Pafta (.KMZ/.KML) Yükle
            </div>
            <input
              type="file"
              accept=".kmz,.kml"
              disabled={!canManagePaftaAndTeams}
              onChange={(event) => {
                if (!canManagePaftaAndTeams) return;
                handleKMZUpload(event);
              }}
              style={{
                width: "100%",
                fontSize: "0.85rem",
                padding: "3px 5px",
                borderRadius: "8px",
                border: `1px solid ${palette.border}`,
                background: canManagePaftaAndTeams ? "#fff" : "#f1f5f9",
                cursor: canManagePaftaAndTeams ? "pointer" : "not-allowed",
                color: canManagePaftaAndTeams ? palette.textPrimary : palette.disabledText,
              }}
            />
            {!canManagePaftaAndTeams ? (
              <div
                style={{
                  marginTop: 4,
                  fontSize: "0.72rem",
                  color: palette.textSecondary,
                  fontWeight: 600,
                }}
              >
                🔒 Pafta yükleme için proje yöneticisi yetkisi gerekir.
              </div>
            ) : null}
          </label>
          <hr
            style={{ margin: "6px 0", borderColor: "#e2e8f0" }}
          />
        </>
      )}

      {/* === PAFTA ARAMA (HER İKİ SEKMEDE ORTAK) === */}
      <div style={{ marginTop: "6px", marginBottom: "6px" }}>
        <input
          type="text"
          placeholder="Pafta ara..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={fieldStyle}
        />
      </div>

      {/* === AKTİF / PASİF PAFTA BAŞLIĞI === */}
      <div
        style={{
          padding: "6px",
          border: `1px solid ${palette.borderSoft}`,
          borderRadius: "10px",
          background: "#f8fafc",
          marginTop: "6px",
          marginBottom: "6px",
          fontWeight: "700",
          fontSize: "0.85rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "6px",
          flexWrap: "wrap",
        }}
      >
        <span style={{ minWidth: 0 }}>
          {paftaTab === "aktif"
            ? `Aktif Paftalar (${aktifPaftaSayisi})`
            : `Pasif Paftalar (${pasifPaftaSayisi})`}
        </span>

        {/* Sadece AKTİF sekmede: Tümünü Seç / Tümünü Kaldır */}
        {paftaTab === "aktif" && (
          <div style={{ display: "flex", gap: "4px", marginLeft: "auto" }}>
            <button
              type="button"
              onClick={() => {
                // Tüm AKTİF paftaları görünür yap
                paftalar
                  .filter((p) => p.aktif)
                  .forEach((p) => {
                    if (!p.gorunur) {
                      paftaGorunurlukDegistir(p.id);
                    }
                  });
              }}
              style={{
                padding: "3px 7px",
                fontSize: "0.75rem",
                borderRadius: "6px",
                border: "1px solid #16a34a",
                cursor: "pointer",
                backgroundColor: palette.success,
                color: "#fff",
                whiteSpace: "nowrap",
                fontWeight: 700,
              }}
            >
              Tümünü Seç
            </button>

            <button
              type="button"
              onClick={() => {
                // Tüm AKTİF paftaları gizle
                paftalar
                  .filter((p) => p.aktif)
                  .forEach((p) => {
                    if (p.gorunur) {
                      paftaGorunurlukDegistir(p.id);
                    }
                  });
              }}
              style={{
                padding: "3px 7px",
                fontSize: "0.75rem",
                borderRadius: "6px",
                border: "1px solid #be123c",
                cursor: "pointer",
                backgroundColor: "#e11d48",
                color: "#fff",
                whiteSpace: "nowrap",
                fontWeight: 700,
              }}
            >
              Tümünü Kaldır
            </button>
          </div>
        )}
      </div>

      {/* === AKTİF / PASİF PAFTA LİSTESİ === */}
      <div
        style={{
          maxHeight: "clamp(260px, 42vh, 440px)",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
          gap: "6px",
          paddingRight: "4px",
        }}
      >
        {paftalar
          .filter((p) =>
            p.isim.toLowerCase().includes(searchTerm.toLowerCase())
          )
          .filter((p) => (paftaTab === "aktif" ? p.aktif : !p.aktif))
          .map((p) => {
            const paftaPoints = points.filter(
              (pt) => pt.paftaId === p.id
            );
            const totalCount = paftaPoints.length;

            return (
              <div
                key={p.id}
                style={{
                  background: "#ffffff",
                  borderRadius: "10px",
                  padding: "6px",
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "0 3px 10px rgba(15,23,42,0.08)",
                  border: p.aktif
                    ? "1px solid #bfdbfe"
                    : "1px solid #e2e8f0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    marginBottom: "6px",
                    gap: 8,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      fontSize: "0.9rem",
                      fontWeight: 600,
                      flex: "1 1 190px",
                      minWidth: 0,
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={p.gorunur}
                      disabled={!p.aktif}
                      onChange={() => {
                        if (!p.aktif) return;
                        paftaGorunurlukDegistir(p.id);
                      }}
                      style={{
                        cursor: p.aktif ? "pointer" : "not-allowed",
                      }}
                    />
                    <span
                      style={{
                        minWidth: 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        color: palette.textPrimary,
                      }}
                    >
                      {p.isim}
                    </span>
                  </div>

                  {p.aktif ? (
                    <button
                      onClick={() => makePaftaPasif(p.id)}
                      disabled={!canManagePaftaAndTeams}
                      title={
                        canManagePaftaAndTeams
                          ? "Paftayı pasif yap"
                          : "Bu işlem için proje yöneticisi yetkisi gerekir."
                      }
                      style={{
                        padding: "2px 6px",
                        backgroundColor: canManagePaftaAndTeams ? palette.danger : palette.disabledBg,
                        color: canManagePaftaAndTeams ? "#fff" : palette.disabledText,
                        border: `1px solid ${canManagePaftaAndTeams ? "#b91c1c" : palette.border}`,
                        borderRadius: "6px",
                        cursor: canManagePaftaAndTeams ? "pointer" : "not-allowed",
                        fontSize: "0.75rem",
                        whiteSpace: "nowrap",
                        fontWeight: 700,
                        opacity: canManagePaftaAndTeams ? 1 : 0.95,
                      }}
                    >
                      {canManagePaftaAndTeams ? "Pasif Yap" : "🔒 Pasif Yap"}
                    </button>
                  ) : (
                    <button
                      onClick={() => makePaftaAktif(p.id)}
                      disabled={!canManagePaftaAndTeams}
                      title={
                        canManagePaftaAndTeams
                          ? "Paftayı aktif yap"
                          : "Bu işlem için proje yöneticisi yetkisi gerekir."
                      }
                      style={{
                        padding: "2px 6px",
                        backgroundColor: canManagePaftaAndTeams ? palette.success : palette.disabledBg,
                        color: canManagePaftaAndTeams ? "#fff" : palette.disabledText,
                        border: `1px solid ${canManagePaftaAndTeams ? "#15803d" : palette.border}`,
                        borderRadius: "6px",
                        cursor: canManagePaftaAndTeams ? "pointer" : "not-allowed",
                        fontSize: "0.75rem",
                        whiteSpace: "nowrap",
                        fontWeight: 700,
                        opacity: canManagePaftaAndTeams ? 1 : 0.95,
                      }}
                    >
                      {canManagePaftaAndTeams ? "Aktif Yap" : "🔒 Aktif Yap"}
                    </button>
                  )}

                  <div
                    style={{
                      flex: "1 0 100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: "8px",
                      paddingLeft: "24px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "0.9rem",
                        fontWeight: 700,
                        color: palette.textSecondary,
                      }}
                    >
                      Toplam: {totalCount}
                    </span>
                    <span
                      style={{
                        fontSize: "0.8rem",
                        fontWeight: 700,
                        color: p.aktif ? "#2563eb" : "#dc2626",
                        background: p.aktif ? "#dbeafe" : "#fee2e2",
                        borderRadius: "999px",
                        padding: "2px 8px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {p.aktif ? "Aktif Pafta" : "Pasif Pafta"}
                    </span>
                  </div>
                </div>

                {/* === PAFTA ALT BUTONLAR: TAKIMLAR / SİL / İNDİR === */}
                <div
                  style={{
                    marginTop: "6px",
                    display: "flex",
                    gap: "4px",
                  }}
                >
                  {p.aktif ? (
                    <>
                      <button
                        onClick={() =>
                          setSelectedPaftaForTeams((prev) =>
                            prev === p.id ? null : p.id
                          )
                        }
                        style={{
                          flex: 1,
                          padding: "4px 4px",
                          background: "#4f46e5",
                          color: "#fff",
                          border: "1px solid #4338ca",
                          borderRadius: "6px",
                          cursor: "pointer",
                          fontSize: "0.75rem",
                          whiteSpace: "nowrap",
                          fontWeight: 700,
                        }}
                      >
                        👥 Takımlar
                      </button>
                      {canManagePaftaAndTeams ? (
                        <button
                          onClick={() => deletePafta(p.id)}
                          style={{
                            flex: 1,
                            padding: "4px 4px",
                            background: palette.danger,
                            color: "#fff",
                            border: "1px solid #b91c1c",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "0.75rem",
                            whiteSpace: "nowrap",
                            fontWeight: 700,
                          }}
                        >
                          🗑 Sil
                        </button>
                      ) : null}
                      <button
                        onClick={() => downloadPafta(p)}
                        style={{
                          flex: 1,
                          padding: "4px 4px",
                          background: palette.accent,
                          color: "#fff",
                          border: "1px solid #0f766e",
                          borderRadius: "6px",
                          cursor: "pointer",
                          fontSize: "0.75rem",
                          whiteSpace: "nowrap",
                          fontWeight: 700,
                        }}
                      >
                        ⬇ İndir
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={() =>
                          setSelectedPaftaForTeams((prev) =>
                            prev === p.id ? null : p.id
                          )
                        }
                        style={{
                          flex: 1,
                          padding: "4px 4px",
                          background: "#4f46e5",
                          color: "#fff",
                          border: "1px solid #4338ca",
                          borderRadius: "6px",
                          cursor: "pointer",
                          fontSize: "0.75rem",
                          whiteSpace: "nowrap",
                          fontWeight: 700,
                        }}
                      >
                        👥 Takımlar
                      </button>
                      <button
                        onClick={() => downloadPafta(p)}
                        style={{
                          flex: 1,
                          padding: "4px 4px",
                          background: palette.accent,
                          color: "#fff",
                          border: "1px solid #0f766e",
                          borderRadius: "6px",
                          cursor: "pointer",
                          fontSize: "0.75rem",
                          whiteSpace: "nowrap",
                          fontWeight: 700,
                        }}
                      >
                        ⬇ İndir
                      </button>
                    </>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
